import { createFileRoute } from "@tanstack/react-router";
import { ScrollTextIcon } from "lucide-react";

import { PoliciesSection } from "../components/regulation/PoliciesSection";
import { PolicyUploadAction } from "../components/regulation/PolicyUploadAction";
import { StartFromTemplateLink } from "../components/regulation/templates/StartFromTemplateLink";
import { RegulationSectionPage } from "../components/regulation/RegulationSectionPage";

import { policyLibrarySearch } from "../components/regulation/policy/policyLibrarySearch";

function LibraryPoliciesRoute() {
  const { q } = Route.useSearch();
  return (
    <RegulationSectionPage
      title="Policies"
      description="Documents feeding your organization's compliance knowledge base."
      emptyIcon={ScrollTextIcon}
      emptyTitle="No policies yet"
      emptyBody="When your organization adopts a policy it appears here, along with every version it has been through. Ask eve to draft your first policy."
      // Uploading is the page's primary action, so it sits with the title
      // rather than above the library it adds to.
      actions={
        <div className="flex flex-wrap items-center gap-2">
          <StartFromTemplateLink />
          <PolicyUploadAction />
        </div>
      }
    >
      <PoliciesSection key={q ?? ""} initialQuery={q ?? ""} />
    </RegulationSectionPage>
  );
}

export const Route = createFileRoute("/$org/compliance/policies/")({
  validateSearch: policyLibrarySearch,
  component: LibraryPoliciesRoute,
});
